import { render, staticRenderFns } from "./CubicMedia.vue?vue&type=template&id=03156180&"
import script from "./CubicMedia.vue?vue&type=script&lang=js&"
export * from "./CubicMedia.vue?vue&type=script&lang=js&"
import style0 from "./CubicMedia.vue?vue&type=style&index=0&id=03156180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports